import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const resources = {
  fetchRowData: async () => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get('/resources', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  fetchDataBasedOnCompany: async (companies: string[]) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/resources/fetch-data-based-on-company',
        {
          companies,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  addResources: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/resources', data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  editResources: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put('/resources', data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  deleteResources: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.delete('/resources', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: data,
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default resources;
